import { useParams, useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Header } from '@/pages/public/landing/components/Header';
import { Footer } from '@/pages/public/landing/components/Footer';
import { useGetBlogPostBySlug } from '@/services/queries/blog';
import { BlogPostContent } from './components/BlogPostContent';

const BlogPostPage = () => {
	const { slug } = useParams<{ slug: string }>();
	const navigate = useNavigate();

	const { data: post, isLoading, isError } = useGetBlogPostBySlug(slug ?? '');

	return (
		<>
			<Header logoHomePath="/" />
			<main className="min-h-screen bg-white">
				{isLoading && (
					<div className="mx-auto max-w-3xl animate-pulse space-y-6 px-6 py-16">
						<div className="h-8 w-3/4 rounded bg-zinc-200" />
						<div className="h-4 w-1/4 rounded bg-zinc-100" />
						<div className="h-64 rounded-2xl bg-zinc-200" />
						<div className="space-y-3">
							{Array.from({ length: 6 }).map((_, i) => (
								<div
									key={i}
									className="h-4 rounded bg-zinc-100"
								/>
							))}
						</div>
					</div>
				)}

				{isError && (
					<div className="mx-auto max-w-2xl px-6 py-32 text-center">
						<h1 className="text-3xl font-bold text-zinc-800">
							Artigo não encontrado
						</h1>
						<p className="mt-4 text-zinc-500">
							O artigo que você está procurando não existe ou foi
							removido.
						</p>
						<button
							onClick={() => navigate('/blog')}
							className="mt-8 inline-flex items-center gap-2 rounded-full bg-brand-pink px-6 py-2.5 text-sm font-semibold text-white transition hover:bg-brand-pink/90"
						>
							<ArrowLeft className="h-4 w-4" />
							Voltar ao Blog
						</button>
					</div>
				)}

				{!isLoading && post && (
					<BlogPostContent
						title={post.title}
						content={post.content}
						banner_url={post.banner_url}
						created_at={post.created_at}
						onBack={() => navigate('/blog')}
					/>
				)}
			</main>
			<Footer />
		</>
	);
};

export { BlogPostPage };
